import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "tillvia-cookie-consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35 }}
          data-testid="cookie-banner"
          role="region"
          aria-label="Samtycke till cookies"
          className="fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-lg rounded-2xl border border-ice bg-white p-5 shadow-2xl shadow-navy/20"
        >
          <div className="flex items-start gap-3">
            <Cookie size={22} className="mt-0.5 shrink-0 text-orange" aria-hidden="true" />
            <div>
              <p className="font-display text-sm font-bold text-navy">Vi använder cookies</p>
              <p className="mt-1 text-sm leading-relaxed text-slate2">
                Vi använder nödvändiga cookies och – med ditt samtycke – analyscookies för att förbättra webbplatsen.
                Läs mer i vår{" "}
                <Link to="/cookiepolicy" className="font-medium text-teal underline underline-offset-2">
                  cookiepolicy
                </Link>
                .
              </p>
            </div>
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              type="button"
              data-testid="cookie-accept-all-button"
              onClick={() => choose("alla")}
              className="rounded-lg bg-orange px-4 py-2.5 font-display text-sm font-bold text-navy transition-colors hover:bg-orange2"
            >
              Acceptera alla
            </button>
            <button
              type="button"
              data-testid="cookie-necessary-button"
              onClick={() => choose("nodvandiga")}
              className="rounded-lg border border-ice bg-white px-4 py-2.5 font-display text-sm font-semibold text-navy transition-colors hover:border-teal hover:text-teal"
            >
              Endast nödvändiga
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
